import { render, staticRenderFns } from "./MainNonogram.vue?vue&type=template&id=9af34828"
import script from "./MainNonogram.vue?vue&type=script&lang=js"
export * from "./MainNonogram.vue?vue&type=script&lang=js"
import style0 from "./MainNonogram.vue?vue&type=style&index=0&id=9af34828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports